// import React from 'react';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import Login from '../pages/auth/login';
// import Dashbord from '../pages/dash/dashbord';
// import Package from '../pages/Package/Package';
// import Packagedetails from '../pages/Package/packagedetails';
// import SlotBooking from '../pages/Slot/slotbooking';
// import AvailableTutors from '../pages/AvailableTutors/AvailableTutors';
// import ForgetPassword from '../pages/auth/ForgetPassword';
// import FreeAssessment from '../pages/Slot/FreeAssessment';
// import BookingAssessment from '../pages/bookingassessment/BookingAssessment';
// import GetwayPayment from '../pages/bookingassessment/Getwaypayment';
// import PaymentGetway from '../pages/bookingassessment/paymentgetway';
// import ClientForm from '../pages/Featured/demopage';
// import ChnagePassword from '../pages/auth/changepassword';
// import Reschedule from '../pages/reschedule/reschedule';

// const Routs = () => {

//   const studentid = localStorage.getItem("studentid");


//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/forget" element={<ForgetPassword />} />
//         <Route path="/changepassword/:id" element={<ChnagePassword />} />
//         <Route path="/dashbord" element={<Dashbord />} />
//         {/* <Route path="/package/:id" element={<Package />} /> */}
//         <Route path="/package" element={<Package />} />
//         {/* <Route path="/packagedetails/:tutorid/:id" element={<Packagedetails/>} /> */}
//         <Route path="/packagedetails/:id" element={<Packagedetails/>} />
//         {/* <Route path="/slotbooking/:id" element={<SlotBooking/>} /> */}
//         <Route path="/slotbooking" element={<SlotBooking/>} />
//         <Route path="/availabletutors/:subject" element={<AvailableTutors/>} />
//         <Route path="/assessment" element={<FreeAssessment/>} />
//         <Route path="/bookingassessment" element={<BookingAssessment/>} />
//         <Route path="/getway" element={<GetwayPayment/>} />
//         <Route path="/paymentgetway" element={<PaymentGetway/>} />
//         <Route path="/reschedule" element={<Reschedule />} />
//       </Routes>
//     </BrowserRouter>
//   );
// };

// export default Routs;


import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/auth/login';
import Dashbord from '../pages/dash/dashbord';
import Package from '../pages/Package/Package';
import Packagedetails from '../pages/Package/packagedetails';
import SlotBooking from '../pages/Slot/slotbooking';
import AvailableTutors from '../pages/AvailableTutors/AvailableTutors';
import ForgetPassword from '../pages/auth/ForgetPassword';
import FreeAssessment from '../pages/Slot/FreeAssessment';
import BookingAssessment from '../pages/bookingassessment/BookingAssessment';
import GetwayPayment from '../pages/bookingassessment/Getwaypayment';
import PaymentGetway from '../pages/bookingassessment/paymentgetway';
import ClientForm from '../pages/Featured/demopage';
import ChnagePassword from '../pages/auth/changepassword';
import Reschedule from '../pages/reschedule/reschedule';
import Startedpage from '../pages/auth/startedpage';

// Private Route – for logged-in users only
const PrivateRoute = ({ children }) => {
  const studentid = localStorage.getItem("studentid");
  return studentid ? children : <Navigate to="/" />;
};

// Public Route – for non-logged-in users only
const PublicRoute = ({ children }) => {
  const studentid = localStorage.getItem("studentid");
  return !studentid ? children : <Navigate to="/dashbord" />;
};

const Routs = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route path="/forget" element={<ForgetPassword />} />
        <Route path="/" element={<Startedpage />} />
        <Route path="/changepassword/:id" element={<ChnagePassword />} />

        <Route
          path="/dashbord"
          element={
            <PrivateRoute>
              <Dashbord />
            </PrivateRoute>
          }
        />

        <Route path="/package" element={<Package />} />
        <Route path="/packagedetails/:id" element={<Packagedetails />} />
        <Route path="/slotbooking" element={<SlotBooking />} />
        <Route path="/availabletutors/:subject" element={<AvailableTutors />} />
        <Route path="/assessment" element={<FreeAssessment />} />
        <Route path="/bookingassessment" element={<BookingAssessment />} />
        <Route path="/getway" element={<GetwayPayment />} />
        <Route path="/paymentgetway" element={<PaymentGetway />} />
        <Route path="/reschedule" element={<Reschedule />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Routs;

